import { Environment } from '@/constants/environment';

export const PROXY_PREFIXES = ['apps', 'a', 'community', 'tools'];

export const getFallbackProxyPath = (): string =>
  process.env.REACT_APP_ENV === Environment.Production ? 'apps/order-tracking' : 'apps/tracking-order-now-dev';

export const validateProxySlug = (slug: string): string => {
  if (!slug) return 'Enter a page name';
  if (slug.length > 30) return 'Use 30 characters or fewer';
  if (!/^[A-Za-z0-9_-]+$/.test(slug)) return 'Use letters, numbers, hyphens or underscores only';
  if (['admin', 'services', 'password', 'login'].includes(slug.toLowerCase())) return `“${slug}” is reserved by Shopify`;
  return '';
};

export const splitProxyPath = (proxyPath: string): { prefix: string; slug: string } => {
  const [prefix, ...rest] = proxyPath.split('/');
  return PROXY_PREFIXES.includes(prefix) ? { prefix, slug: rest.join('/') } : { prefix: PROXY_PREFIXES[0], slug: proxyPath };
};

export const buildTrackingPageUrl = (shop: string, proxyPath?: string | null, trackingNumber?: string): string => {
  const base = `https://${shop}/${proxyPath || getFallbackProxyPath()}`;
  return trackingNumber ? `${base}?tracking_number=${trackingNumber}` : base;
};

export const buildShopifyAppSettingsUrl = (shop: string): string => {
  const storeHandle = shop.split('.')[0];
  const appHandle = process.env.REACT_APP_SHOPIFY_APP_HANDLE || 'tracking-order-now-1';
  const base = `https://admin.shopify.com/store/${storeHandle}/settings/apps`;
  return `${base}/app_installations/app/${appHandle}`;
};
